module.exports = __webpack_public_path__ + "img/a3-s84.913faa80.jpg";